export default __webpack_public_path__ + "static/media/tirangleRight.85a71adf.svg";